import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { InputAdornment } from "@mui/material";
import { Stack } from "@mui/system";
import SearchIcon from "@mui/icons-material/Search";
import ProcessLogsFilter from "./ProcessLogsFilter";

const ProcessLogsFilterCard = () => {
  const FakeData = [
    { label: "RevShare" },
    { label: "CTR Percentages" },
    { label: "Click Out" },
    { label: "Overall Speed Performance" },
  ];

  return (
    <Stack
      direction="row"
      spacing={2}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{ width: "100%" }}
    >
      <Stack direction="row" gap={2} alignItems={"center"}>
        <Autocomplete
          disablePortal
          size="small"
          sx={{ width: 300 }}
          options={FakeData}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Brand Name"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ marginLeft: "12px" }} />
                  </InputAdornment>
                ),
              }}
              color="secondary"
            />
          )}
        />
        <ProcessLogsFilter />
      </Stack>
    </Stack>
  );
};

export default ProcessLogsFilterCard;
